var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupMenuYouOwn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 5.33333C9.99992 3.49239 8.50752 2 6.66659 2C4.82564 2 3.33325 3.49239 3.33325 5.33333C3.33325 7.17427 4.82564 8.66667 6.66659 8.66667C8.50752 8.66667 9.99992 7.17427 9.99992 5.33333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 5.33333C9.99992 3.49239 8.50752 2 6.66659 2C4.82564 2 3.33325 3.49239 3.33325 5.33333C3.33325 7.17427 4.82564 8.66667 6.66659 8.66667C8.50752 8.66667 9.99992 7.17427 9.99992 5.33333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.3337C2 10.7563 4.08934 8.66699 6.66667 8.66699C7.63265 8.66699 8.53009 8.9605 9.27466 9.46318",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.3337C2 10.7563 4.08934 8.66699 6.66667 8.66699C7.63265 8.66699 8.53009 8.9605 9.27466 9.46318",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58325 12C7.58325 12 9.26319 12.8389 9.83325 14.5C9.83325 14.5 12.6127 10.3333 15.0833 9.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58325 12C7.58325 12 9.26319 12.8389 9.83325 14.5C9.83325 14.5 12.6127 10.3333 15.0833 9.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMenuYouOwn);
export default __webpack_public_path__ + "static/media/group_menu_you_own.a293e0649146b9638ba1d0f901821525.svg";
export { ForwardRef as ReactComponent };